const STORAGE_KEY = "runmark:acquisition";

export type AcquisitionParams = {
  source: string;
  medium: string;
  campaign: string;
  term: string;
  content: string;
  landingPage: string;
};

// First-touch attribution: once a UTM-tagged landing is captured it is kept
// for the life of the browser (localStorage), even if the user signs up on a
// later, untagged visit.
export function captureAcquisitionParams(search: string, pathname: string): void {
  if (typeof window === "undefined" || window.localStorage.getItem(STORAGE_KEY)) {
    return;
  }

  const params = new URLSearchParams(search);
  const source = params.get("utm_source");
  if (!source) {
    return;
  }

  const acquisition: AcquisitionParams = {
    source,
    medium: params.get("utm_medium") ?? "",
    campaign: params.get("utm_campaign") ?? "",
    term: params.get("utm_term") ?? "",
    content: params.get("utm_content") ?? "",
    landingPage: pathname,
  };

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(acquisition));
}

export function getStoredAcquisitionParams(): AcquisitionParams | null {
  if (typeof window === "undefined") {
    return null;
  }

  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as AcquisitionParams;
  } catch {
    return null;
  }
}
